const locale = {
	USER_DISABLED: 'Accesso disabilitato',

	DETAILS_USERS_TAB_ACTIVITIES_KANBAN: 'Kanban Attività',
	DETAILS_USERS_TAB_OPPORTUNITIES_KANBAN: 'Kanban Opportunità',

	// #region User fields
	DETAILS_USERS_FIELD_NAME: 'Nome',
	DETAILS_USERS_FIELD_SURNAME: 'Cognome',
	DETAILS_USERS_FIELD_MAIL: 'Indirizzo Email Login',
	DETAILS_USERS_FIELD_RECRUITMENT_DATE: 'Data assunzione',
	DETAILS_USERS_FIELD_BIRTHDAY: 'Compleanno',
	DETAILS_USERS_FIELD_ERP_ID: 'ID Responsabile Contatto NAV',
	DETAILS_USERS_FIELD_ERP_SALESPERSON_ID: 'ID Agente NAV',
	DETAILS_USERS_FIELD_HOURLY_RATE: 'Costo orario',
	DETAILS_USERS_FIELD_ENABLED: 'Attivo',

	DETAILS_USERS_SECTION_USE_EXISTING: 'Usa utente esistente',
	DETAILS_USERS_SECTION_ADD_NEW: 'Aggiungi nuovo utente',
	DETAILS_USERS_FIELD_PASSWORD: 'Password',
	DETAILS_USERS_FIELD_CONFIRM_PASSWORD: 'Conferma Password',
	DETAILS_USERS_FIELD_FORCE_RESET_PASSWORD: 'Deve cambiare password',
	DETAILS_USERS_CHANGE_PASSWORD_TEXT: 'Per modificare la password vai in modalità modifica',
	DETAILS_USERS_FIELD_ROLE: 'Ruolo Utente',
	// #endregion

	// #region User Avatar
	USERS_AVATAR_SECTION: 'Avatar',
	USERS_AVATAR_SUBHEADER: "Visualizza o aggiorna l'avatar del tuo profilo",
	// #endregion

	// #region Details system user creation
	USERS_SYSTEM_USER_CREATION_SECTION: 'Dati Utente Perceptive',
	USERS_SYSTEM_USER_CREATION_SUBHEADER: 'Usa un utente Perceptive Suite esistente o creane uno nuovo.',
	// #endregion

	// #region Details user system info
	USERS_APPSETTINGS_SECTION: 'Account Perceptive',
	USERS_APPSETTINGS_SUBHEADER: "Visualizza i dettagli dell'Account Perceptive",
	LOGIN_EMAIL: 'Indirizzo Mail Login',
	ROLE: 'Ruolo',
	LAST_LOGIN: 'Ultimo accesso',
	PASSWORD: 'Password',
	LOGIN_EMAIL_EDIT_BUTTON: 'Modifica Mail Login',

	DETAILS_USERS_STATUS_TITLE: 'Stato',
	DETAILS_USERS_STATUS_ACTIVE: 'ATTIVO',
	DETAILS_USERS_STATUS_DISABLED: 'DISATTIVATO',
	// #endregion

	// #region Change Login Mail Dialog
	DIALOG_LOGIN_MAIL_TITLE: 'Modifica Mail di Login',
	DIALOG_LOGIN_MAIL_DESCRIPTION1: 'Utilizza il campo "Mail" per modificare la mail di login.',
	DIALOG_LOGIN_MAIL_DESCRIPTION2: "Attenzione! L'indirizzo di login verrà modificato per tutte le App Perceptive.",
	DIALOG_LOGIN_EMAIL_FIELD: 'Mail',
	// #endregion

	// #region User's integrations
	USERS_INTEGRATION_MAILCHIMP_SECTION: 'Account Mailchimp',
	USERS_INTEGRATION_MAILCHIMP_SUBHEADER: 'Visualizza le informazioni del tuo account Mailchimp',

	USERS_INTEGRATION_MAILUP_SECTION: 'Account Mailup',
	USERS_INTEGRATION_MAILUP_SUBHEADER: 'Visualizza le informazioni del tuo account Mailup',
	// #endregion

	// #region Details User Permissions section
	USERS_PERMISSIONS_SECTION: 'Permessi applicazione',
	USERS_PERMISSIONS_SUBHEADER: "Visualizza e modifica le impostazioni dei permessi dell'applicazione",
	NOT_SUPPORTED: 'Impostazione non supportata dal browser',
	PUSH_NOTIFICATIONS_SETTING: 'Notifiche push',
	SPEECH_TO_TEXT_SETTING: 'Dettatura',
	MAIL_NOTIFICATION_SETTING: 'Notifiche mail',
	// #endregion

	// #region Details User Saved Filters section
	USERS_SAVEDFILTERS_SECTION: 'Filtri salvati',
	USERS_SAVEDFILTERS_SUBHEADER: "Visualizza i filtri salvati dall'Utente",
	// #endregion

	// #region Settings Mailchimp user account details
	SETTINGS_USER_ACCOUNT_MAILCHIMP_MEMBER_SINCE: 'Membro da: {date}',
	SETTINGS_USER_ACCOUNT_MAILCHIMP_SUBSCRIBERS: 'Iscritti: {subscribers} / {tot}',
	SETTINGS_USER_ACCOUNT_MAILCHIMP_PLAN: 'Tipo piano: {type}',
	// #endregion

	// #region Settings Mailup user account details
	SETTINGS_USER_ACCOUNT_MAILUP_EXPIRY_DATE: 'Data scadenza: {date}',
	// #endregion

	// #region User Daily Report
	USERS_DAILYREPORT_SECTION: 'Email di riepilogo giornaliera',
	USERS_DAILYREPORT_SUBHEADER: "Attiva/disattiva l'email di riepilogo giornaliera",

	DIALOG_TITLE_DAILY_REPORT_SETTINGS: 'Impostazioni email di riepilogo giornaliera',
	DAILY_REPORT_FIELD_TEMPLATE: 'Nome template',
	DAILY_REPORT_FIELD_CRON: 'Cron',

	DAILY_REPORT_TEMPLATE: 'Template: {template}',
	DAILY_REPORT_TYPE: 'Tipo: {type}',
	DAILY_REPORT_CREATEDAT: 'Creato il {date}',
	DAILY_REPORT_NEXTEXECUTION: 'Prossima esecuzione il {date}',
	DAILY_REPORT_RECURRENCE: 'Ricorrenza: "{cron}"',

	DAILY_REPORT_UNIT_WEEK: 'settimane',
	DAILY_REPORT_UNIT_DAY: 'giorni',
	DAILY_REPORT_UNIT_HOUR: 'ore',
	DAILY_REPORT_UNIT_MINUTE: 'minuti',
	// #endregion

	USER_LOGIN_LOGS: 'Log accessi'
};

export default locale;
